import { Detail, DetailTitle } from "components/atoms/detail"
import { RecruitContainer } from "components/atoms/recruit"
import React, { useMemo } from "react"
import { Link } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { recruitsState } from "recoils/recruitsState"
import styled from "styled-components"

import { Button } from "../atoms/Button"

import type { Recruit } from "interfaces/RecruitIF"

export const RecruitListView = ({
  children,
  ...props
}: React.ComponentProps<typeof Detail>) => {
  const recruits = useRecoilValue<Recruit[]>(recruitsState)

  const disabledCreated = useMemo(() => {
    return recruits.length >= 3
  }, [recruits])

  return (
    <Detail {...props}>
      <Header>
        <DetailTitle>求人登録画面</DetailTitle>
        <Link to="/recruit/new">
          <Button className="primary" disabled={disabledCreated}>
            新規作成
          </Button>
        </Link>
      </Header>
      <Description>
        作成可能な求人は最大3件までです。既存の求人を削除することで、追加の求人を作成できます。
      </Description>
      {recruits.length === 0 ? (
        <EmptyText>作成した求人はありません</EmptyText>
      ) : (
        <RecruitContainer recruits={recruits}></RecruitContainer>
      )}
      {children}
    </Detail>
  )
}

const Header = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Description = styled.p`
  margin: 20px auto 0;
`

const EmptyText = styled.p`
  margin: 50px auto 0;
  text-align: center;
  font-size: 18px;
`
